export {};
//# sourceMappingURL=pick-element-from-set-function.js.map